import * as React from 'react';
import { ArrowChevronRight } from '../../icons';
import { ActionItemButton } from '../../components';
export function ActiveList(props) {
    var idKey = props.idKey, labelKey = props.labelKey, onChange = props.onChange, defaultItem = props.defaultItem, visible = props.visible;
    var _a = React.useState(defaultItem), activeItem = _a[0], setActiveItem = _a[1];
    function handleClick(item) {
        return function () {
            setActiveItem(item);
            if (onChange !== undefined)
                onChange(item);
        };
    }
    return (React.createElement(React.Fragment, null, visible.map(function (item) {
        var isActive = activeItem !== undefined && activeItem[idKey] === item[idKey];
        return (React.createElement(ActionItemButton, { key: String(item[idKey]), isActive: isActive, onClick: handleClick(item), iconRight: React.createElement(ArrowChevronRight, { tiny: true }) }, item[labelKey]));
    })));
}
//# sourceMappingURL=ActiveList.js.map